import { useUiV2 } from '@/ui-v2/use-ui-v2'

/**
 * Kolory slajdu — JEDNO zrodlo dla trzech miejsc, ktore musza wygladac tak samo:
 * podgladu talii, prezentera i pliku PPTX.
 *
 * Dlaczego heksy, a nie tokeny Tailwinda: `export-pptx.ts` buduje plik przez
 * pptxgenjs, ktory nie ma pojecia o CSS-ie i przyjmuje wylacznie wartosci
 * heksadecymalne. Do tej pory trzymal wiec wlasna kopie palety — i po zmianie
 * motywu talia na ekranie byla fioletowa, a ta sama talia pobrana do PowerPointa
 * nadal niebiesko-pomaranczowa. Nauczyciel zobaczylby to dopiero w klasie, na
 * rzutniku. Skoro plik i tak wymusza heksy, to one sa zrodlem, a podglad z nich
 * korzysta (style inline), zamiast odwrotnie.
 *
 * Bez `#`, bo tego wymaga pptxgenjs; podglad dokleja go sam (`hex()`).
 */
export type SlideTheme = {
  /** tlo slajdu */
  surface: string
  /** kolor naglowkow i platu sekcji */
  primary: string
  /** tekst na placie sekcji */
  onPrimary: string
  /** akcent: podkreslenie naglowka, etykieta „PYTANIE" */
  accent: string
  /** tresc */
  ink: string
  /** tresc drugorzedna, podpowiedzi */
  muted: string
  /** tlo bloku podpowiedzi w slajdzie-pytaniu */
  softBg: string
  /** znaczniki punktow */
  bullet: string
}

/** Paleta sprzed redesignu — zostaje, dopoki v1 da sie wlaczyc. */
export const SLIDE_THEME_V1: SlideTheme = {
  surface: 'FFFFFF',
  primary: '4C5596',
  onPrimary: 'FFFFFF',
  accent: 'F97316',
  ink: '1A1D33',
  muted: '6B7280',
  softBg: 'F3F4F6',
  bullet: '4C5596',
}

/** Paleta redesignu („Pastel", D1) — te same wartosci co w styles/theme-v2.css. */
export const SLIDE_THEME_V2: SlideTheme = {
  surface: 'FFFFFF',
  primary: '543885',
  onPrimary: 'FFFFFF',
  accent: 'FFC42E',
  ink: '2A2440',
  muted: '5A5474',
  softBg: 'F1ECFA',
  bullet: 'B9A5E0',
}

export function useSlideTheme(): SlideTheme {
  return useUiV2() ? SLIDE_THEME_V2 : SLIDE_THEME_V1
}

/** `543885` -> `#543885`; do stylow inline w podgladzie. */
export function hex(color: string): string {
  return `#${color}`
}
